/* Realizzandoo Configurator v2 — schema-driven engine
   Lavora con il markup di rlz-configurator-v2.liquid
   Schema definito da product.metafields.rlz.configurator
*/
(function () {
  'use strict';

  // ===== Color map per name_input lettering preview =====
  var COLOR_HEX = {
    'bianco': '#FFFFFF', 'white': '#FFFFFF',
    'nero': '#0F0F0F', 'black': '#0F0F0F',
    'rosa': '#F8B4C8', 'pink': '#F8B4C8',
    'rosso': '#D14B4B', 'red': '#D14B4B',
    'arancione': '#F2925E', 'orange': '#F2925E',
    'giallo': '#F4D35E', 'yellow': '#F4D35E',
    'verde': '#5BB191', 'green': '#5BB191',
    'celeste': '#7FCDE3', 'azzurro': '#7FCDE3',
    'blu': '#3F5BAE', 'blue': '#3F5BAE',
    'viola': '#7B66B8', 'purple': '#7B66B8',
    'fucsia': '#D247A0',
    'beige': '#D4B998',
    'marrone': '#8B5E3C',
    'oro': '#D4AF37', 'gold': '#D4AF37',
    'argento': '#C0C0C0', 'silver': '#C0C0C0',
    'multicolor': 'linear-gradient(135deg, #F8B4C8 0%, #F4D35E 25%, #5BB191 50%, #7FCDE3 75%, #7B66B8 100%)'
  };

  function colorForValue(v) {
    var key = (v || '').toLowerCase().replace(/^\d+\s*-\s*/, '').trim();
    // try exact match first
    if (COLOR_HEX[key]) return COLOR_HEX[key];
    // try first word
    var w = key.split(' ')[0];
    if (COLOR_HEX[w]) return COLOR_HEX[w];
    return '#3f388b';
  }

  document.querySelectorAll('[data-rlz-configurator-v2]').forEach(initWizard);

  function initWizard(root) {
    var schemaEl = root.querySelector('[data-rlz-schema]');
    if (!schemaEl) return;
    var schema;
    try {
      schema = JSON.parse(schemaEl.textContent);
    } catch (e) {
      console.error('[rlz-cfg-v2] Schema JSON invalid:', e);
      return;
    }
    if (!schema || !schema.active || !Array.isArray(schema.steps)) return;

    function safeJson(selector, fallback) {
      var el = root.querySelector(selector);
      if (!el) { console.warn('[rlz-cfg-v2] missing', selector); return fallback; }
      try { return JSON.parse(el.textContent || 'null') || fallback; }
      catch (e) { console.error('[rlz-cfg-v2] invalid JSON in', selector, e); return fallback; }
    }
    var variants = safeJson('[data-rlz-variants]', []);
    var optionNames = safeJson('[data-rlz-options]', []);
    var i18n = safeJson('[data-rlz-i18n]', {});
    if (!variants.length) { console.error('[rlz-cfg-v2] no variants — aborting'); return; }

    // Map step.id → product option position (0-indexed).
    // Strategy: name-match against product.options FIRST (handles arbitrary schema UI order
    // when product option order ≠ schema step order). Fallback to schema-order position
    // for stores with translated option.name where name match fails.
    var NONE_MARKER = '__rlz_none__';
    var stepOptionIdx = {};
    (function () {
      var schemaPos = 0;
      schema.steps.forEach(function (s) {
        if (s.type === 'option_pill' || s.type === 'option_swatch' || s.type === 'option_image' || s.type === 'color_swatch') {
          var idx = -1;
          if (s.option && Array.isArray(optionNames)) idx = optionNames.indexOf(s.option);
          stepOptionIdx[s.id] = (idx !== -1) ? idx : schemaPos;
          schemaPos++;
        }
      });
    })();

    var hero = root.querySelector('[data-rlz-hero]');
    var wizard = root.querySelector('[data-rlz-wizard]');
    var startBtn = root.querySelector('[data-rlz-start]');
    var panels = Array.prototype.slice.call(root.querySelectorAll('.rlz-cfg__panel'));
    var stepTicks = Array.prototype.slice.call(root.querySelectorAll('.rlz-cfg__step-tick'));
    var variantInput = root.querySelector('[data-rlz-final-variant]');
    var finalNameInput = root.querySelector('[data-rlz-final-name]');
    var currentStepLabel = root.querySelector('[data-rlz-step-current]');
    var totalStepLabel = root.querySelector('[data-rlz-step-total]');
    var previewText = root.querySelector('[data-rlz-preview-text]');
    var heartCheckbox = root.querySelector('[data-rlz-heart]');
    var nameInput = root.querySelector('[data-step-name-input]');
    var charCount = root.querySelector('[data-rlz-char-count]');
    var nameError = root.querySelector('[data-rlz-name-error]');
    var reviewSummary = root.querySelector('[data-rlz-review-summary]');
    var reviewPrice = root.querySelector('[data-rlz-review-price]');
    var form = root.querySelector('form');

    // State: step.id -> selected value
    var state = {};
    // current visible step index (within visible-only sequence)
    var currentIdx = 0;

    // ===== Start button =====
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        if (hero) hero.style.display = 'none';
        if (wizard) wizard.style.display = '';
        recomputeVisibility();
        showFirstVisible();
      });
    }

    // ===== Step click handlers =====
    root.querySelectorAll('[data-step-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var stepId = btn.dataset.stepId;
        var value = btn.dataset.value;
        setStepValue(stepId, value, btn);
      });
    });

    // ===== Name input handler =====
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        syncNamePreview();
        var stepId = nameInput.dataset.stepId;
        state[stepId] = nameInput.value;
      });
    }
    if (heartCheckbox) heartCheckbox.addEventListener('change', syncNamePreview);

    // ===== "Nessuna decorazione" toggle handler =====
    root.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-rlz-none-toggle]');
      if (!cb) return;
      var stepId = cb.getAttribute('data-rlz-none-toggle');
      var step = findStepById(stepId);
      if (!step) return;
      var propInput = root.querySelector('[data-rlz-none-property="' + stepId + '"]');
      var lbl = root.querySelector('[data-rlz-selected-label="' + stepId + '"]');
      if (cb.checked) {
        state[stepId] = NONE_MARKER;
        if (propInput) propInput.value = step.none_property_value || step.none_label || 'Nessuna';
        if (lbl) lbl.textContent = step.none_label || 'Nessuna';
        // De-select all option buttons for this step
        root.querySelectorAll('.rlz-cfg__panel[data-step-id="' + stepId + '"] [data-step-value]').forEach(function (btn) {
          btn.classList.remove('is-selected');
        });
      } else {
        delete state[stepId];
        if (propInput) propInput.value = '';
        if (lbl) lbl.textContent = '—';
      }
      updateVariant();
      updateAvailability();
      refreshAllStockFilters();
    });

    // ===== Next/Back nav =====
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-rlz-next]')) {
        e.preventDefault();
        if (validateCurrentStep()) goNext();
      }
      if (e.target.closest('[data-rlz-back]')) {
        e.preventDefault();
        goBack();
      }
    });

    // ===== Form submit (default = Aggiungi + checkout) =====
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart('checkout');
      });
    }

    // ===== "Aggiungi e personalizza un altro" button =====
    var btnAddAnother = root.querySelector('[data-rlz-add-and-personalize]');
    if (btnAddAnother) {
      btnAddAnother.addEventListener('click', function () {
        addToCart('another');
      });
    }

    // ===== "Personalizza un altro" (post-success) -> reset configuratore =====
    var btnAnotherYes = root.querySelector('[data-rlz-another-yes]');
    if (btnAnotherYes) {
      btnAnotherYes.addEventListener('click', function () {
        resetConfigurator();
      });
    }

    // ===== Availability check: data una option+value, esiste almeno una variante con altre selezioni correnti? =====
    // IMPORTANTE: solo gli step EARLIER nello schema constrainano. Gli step successivi sono "free":
    // se cambi una decisione earlier, gli step later vanno re-scelti, non devono bloccare il bottone.
    function isValueAvailable(stepId, value) {
      var step = findStepById(stepId);
      if (!step || stepOptionIdx[stepId] === undefined) return true;
      var stepIdxInSchema = schema.steps.findIndex(function (s) { return s.id === stepId; });
      var trialByIdx = {};
      schema.steps.forEach(function (s, idx) {
        if (idx < stepIdxInSchema && stepOptionIdx[s.id] !== undefined && state[s.id] && state[s.id] !== NONE_MARKER) {
          trialByIdx[stepOptionIdx[s.id]] = state[s.id];
        }
      });
      trialByIdx[stepOptionIdx[stepId]] = value;
      return variants.some(function (v) {
        if (v.available === false) return false;
        for (var idx in trialByIdx) {
          if (v.options[parseInt(idx, 10)] !== trialByIdx[idx]) return false;
        }
        return true;
      });
    }

    // ===== Stock check: ALL values of this step out of stock (inventory_quantity == 0) for current other selections =====
    function isStepFullyOutOfStock(step) {
      if (!step || !step.out_of_stock_check) return false;
      if (stepOptionIdx[step.id] === undefined) return false;
      var stepIdx = stepOptionIdx[step.id];
      // Collect all unique values for this option from variants
      var allValues = {};
      variants.forEach(function (v) {
        if (v.options && v.options[stepIdx] != null) allValues[v.options[stepIdx]] = true;
      });
      var values = Object.keys(allValues);
      for (var i = 0; i < values.length; i++) {
        var value = values[i];
        var trial = {};
        schema.steps.forEach(function (s) {
          if (stepOptionIdx[s.id] !== undefined && state[s.id] && state[s.id] !== NONE_MARKER && s.id !== step.id) {
            trial[stepOptionIdx[s.id]] = state[s.id];
          }
        });
        trial[stepIdx] = value;
        var hasStock = variants.some(function (v) {
          for (var idx in trial) {
            if (v.options[parseInt(idx, 10)] !== trial[idx]) return false;
          }
          return (typeof v.inventory_quantity !== 'undefined' && v.inventory_quantity > 0);
        });
        if (hasStock) return false;
      }
      return true;
    }

    // ===== Apply OOS / none-toggle state to UI =====
    function updateOosState(step) {
      if (!step || !step.out_of_stock_check) return;
      var msgEl = root.querySelector('[data-rlz-oos-message="' + step.id + '"]');
      var grp = root.querySelector('.rlz-cfg__panel[data-step-id="' + step.id + '"] .rlz-cfg__option-group');
      var noneToggleWrap = root.querySelector('[data-rlz-none-toggle-wrap][data-step-id="' + step.id + '"]');
      var propInput = root.querySelector('[data-rlz-none-property="' + step.id + '"]');
      var lbl = root.querySelector('[data-rlz-selected-label="' + step.id + '"]');
      var oos = isStepFullyOutOfStock(step);
      if (oos) {
        if (msgEl) msgEl.style.display = '';
        if (grp) grp.style.display = 'none';
        if (noneToggleWrap) noneToggleWrap.style.display = 'none';
        // Auto-set NONE state + emit property
        state[step.id] = NONE_MARKER;
        if (propInput) propInput.value = step.none_property_value || step.none_label || 'Nessuna';
        if (lbl) lbl.textContent = step.none_label || 'Nessuna';
      } else {
        if (msgEl) msgEl.style.display = 'none';
        if (grp) grp.style.display = '';
        if (noneToggleWrap) noneToggleWrap.style.display = '';
        // Clear AUTO-NONE state if user has not manually checked the none toggle
        var noneToggle = root.querySelector('[data-rlz-none-toggle="' + step.id + '"]');
        var userToggled = noneToggle && noneToggle.checked;
        if (state[step.id] === NONE_MARKER && !userToggled) {
          delete state[step.id];
          if (propInput) propInput.value = '';
          if (lbl) lbl.textContent = '—';
        }
      }
    }

    function refreshAllOosSteps() {
      schema.steps.forEach(function (s) { if (s.out_of_stock_check) updateOosState(s); });
    }

    // ===== Stock-aware filter: hide values without inventory for current state =====
    function hasStockForValue(stepId, value) {
      if (stepOptionIdx[stepId] === undefined) return true;
      var stepIdxInSchema = schema.steps.findIndex(function (s) { return s.id === stepId; });
      var trial = {};
      schema.steps.forEach(function (s, idx) {
        if (idx < stepIdxInSchema && stepOptionIdx[s.id] !== undefined && state[s.id] && state[s.id] !== NONE_MARKER) {
          trial[stepOptionIdx[s.id]] = state[s.id];
        }
      });
      trial[stepOptionIdx[stepId]] = value;
      return variants.some(function (v) {
        for (var idx in trial) {
          if (v.options[parseInt(idx, 10)] !== trial[idx]) return false;
        }
        return (typeof v.inventory_quantity !== 'undefined' && v.inventory_quantity > 0);
      });
    }

    function applyStockFilter(step) {
      if (!step || !step.filter_by_stock) return;
      if (stepOptionIdx[step.id] === undefined) return;
      var btns = root.querySelectorAll('.rlz-cfg__panel[data-step-id="' + step.id + '"] [data-step-value]');
      var anyVisible = false;
      btns.forEach(function (btn) {
        var value = btn.dataset.value;
        var ok = hasStockForValue(step.id, value);
        btn.classList.toggle('rlz-cfg__hidden-by-stock', !ok);
        btn.style.display = ok ? '' : 'none';
        if (ok) anyVisible = true;
        // If current state for this step is now hidden, clear it
        if (!ok && state[step.id] === value) {
          delete state[step.id];
          var lbl = root.querySelector('[data-rlz-selected-label="' + step.id + '"]');
          if (lbl) lbl.textContent = '—';
          btn.classList.remove('is-selected');
        }
      });
    }

    function refreshAllStockFilters() {
      schema.steps.forEach(function (s) { if (s.filter_by_stock) applyStockFilter(s); });
    }

    function updateAvailability() {
      schema.steps.forEach(function (step) {
        if (stepOptionIdx[step.id] === undefined) return;
        var btns = root.querySelectorAll('[data-step-id="' + step.id + '"][data-step-value]');
        btns.forEach(function (btn) {
          var ok = isValueAvailable(step.id, btn.dataset.value);
          btn.classList.toggle('is-unavailable', !ok);
          btn.disabled = !ok;
          btn.setAttribute('aria-disabled', !ok);
        });
      });
    }

    // ===== Core: set step value =====
    function setStepValue(stepId, value, btnEl) {
      var prevValue = state[stepId];
      state[stepId] = value;
      // If the value of an earlier step changes, clear later option-step selections
      // (their previous value may not match the new earlier choice, and could even hide invalid variants)
      if (prevValue !== value) {
        var changedIdxInSchema = schema.steps.findIndex(function (s) { return s.id === stepId; });
        if (changedIdxInSchema !== -1) {
          schema.steps.forEach(function (s, idx) {
            if (idx > changedIdxInSchema && stepOptionIdx[s.id] !== undefined) {
              if (state[s.id]) {
                delete state[s.id];
                var lbl = root.querySelector('[data-rlz-selected-label="' + s.id + '"]');
                if (lbl) lbl.textContent = '—';
                root.querySelectorAll('.rlz-cfg__panel[data-step-id="' + s.id + '"] [data-step-value]').forEach(function (btn) {
                  btn.classList.remove('is-selected');
                });
                // Reset none toggle + property on later steps too
                var ncb = root.querySelector('[data-rlz-none-toggle="' + s.id + '"]');
                if (ncb) ncb.checked = false;
                var np = root.querySelector('[data-rlz-none-property="' + s.id + '"]');
                if (np) np.value = '';
              }
            }
          });
        }
      }
      // Update label
      var lbl = root.querySelector('[data-rlz-selected-label="' + stepId + '"]');
      if (lbl) {
        var btn = root.querySelector('[data-step-id="' + stepId + '"][data-value="' + value.replace(/"/g, '\\"') + '"]');
        var labelText = btn ? (btn.querySelector('.rlz-cfg__color-swatch-label, .rlz-cfg__img-swatch-label, .rlz-cfg__swatch-label')?.textContent || value) : value;
        lbl.textContent = labelText.trim();
      }
      // Mark selected
      root.querySelectorAll('[data-step-id="' + stepId + '"]').forEach(function (b) {
        if (b.dataset.stepValue !== undefined || b.hasAttribute('data-step-value')) {
          b.classList.toggle('is-selected', b.dataset.value === value);
        }
      });
      // Recompute visibility (dependent steps may now show/hide)
      recomputeVisibility();
      // Update variant
      updateVariant();
      // Aggiorna disponibilità di tutti gli step (disabilita combinazioni invalide)
      updateAvailability();
      // Refresh OOS state for any steps with out_of_stock_check (e.g. Decorazione reacts to Colore)
      refreshAllOosSteps();
      // Refresh stock filters for steps with filter_by_stock (hide values without inventory)
      refreshAllStockFilters();
      // If user picked a real value on a none-allowed step, uncheck none toggle + clear property
      var noneToggleForStep = root.querySelector('[data-rlz-none-toggle="' + stepId + '"]');
      if (noneToggleForStep) noneToggleForStep.checked = false;
      var nonePropForStep = root.querySelector('[data-rlz-none-property="' + stepId + '"]');
      if (nonePropForStep) nonePropForStep.value = '';
      // Update extra_select hidden input
      var step = findStepById(stepId);
      if (step && step.type === 'extra_select') {
        var hidden = root.querySelector('[data-rlz-extra-input="' + stepId + '"]');
        if (hidden) hidden.value = value;
      }
      // Update lettering color preview if applicable
      var colorSourceStep = schema.steps.find(function (s) { return s.color_from === stepId; });
      if (colorSourceStep) {
        applyLetteringColor(value);
      }
    }

    // ===== Variant lookup (locale-invariant: matches by option position, not name) =====
    function updateVariant() {
      var optByIdx = {};
      schema.steps.forEach(function (step) {
        if (stepOptionIdx[step.id] !== undefined && state[step.id] && state[step.id] !== NONE_MARKER) {
          optByIdx[stepOptionIdx[step.id]] = state[step.id];
        }
      });
      var match = variants.find(function (v) {
        for (var idx in optByIdx) {
          if (v.options[parseInt(idx, 10)] !== optByIdx[idx]) return false;
        }
        return true;
      });
      if (match && variantInput) {
        variantInput.value = match.id;
        if (reviewPrice) reviewPrice.textContent = formatMoney(match.price);
        document.dispatchEvent(new CustomEvent('rlz:variant-change', { detail: { variant: match } }));
      }
    }

    var __rlzMoneyFormatter = (function () {
      var locale = 'en';
      var currency = 'EUR';
      try {
        var cfgEl = root.querySelector('[data-rlz-money-cfg]');
        if (cfgEl) {
          var cfg = JSON.parse(cfgEl.textContent || '{}');
          if (cfg.locale) locale = cfg.locale;
          if (cfg.currency) currency = cfg.currency;
        }
      } catch (e) {}
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: currency });
      } catch (e) {
        return { format: function (n) { return currency + ' ' + n.toFixed(2); } };
      }
    })();
    function formatMoney(cents) {
      return __rlzMoneyFormatter.format((cents || 0) / 100);
    }

    // ===== Visibility (show_if) =====
    function isStepVisible(step) {
      if (!step.show_if) return true;
      var depVal = state[step.show_if.step];
      if (depVal == null) return false;
      return (step.show_if.value_in || []).indexOf(depVal) !== -1;
    }

    function recomputeVisibility() {
      schema.steps.forEach(function (step) {
        var visible = isStepVisible(step);
        var panel = root.querySelector('.rlz-cfg__panel[data-step-id="' + step.id + '"]');
        if (panel) panel.dataset.visible = visible ? 'true' : 'false';
        var dot = root.querySelector('[data-step-dot="' + step.id + '"]');
        if (dot) dot.dataset.visible = visible ? 'true' : 'false';
      });
      updateStepCounter();
    }

    function visibleSteps() {
      return schema.steps.filter(isStepVisible);
    }

    function updateStepCounter() {
      // Total = schema.steps.length (fisso, non dinamico)
      if (totalStepLabel) totalStepLabel.textContent = schema.steps.length;
      // Current = position of current step in schema (1-indexed)
      if (currentStepLabel) currentStepLabel.textContent = currentIdx + 1;
    }

    // ===== Step navigation =====
    function showStep(idx) {
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
      stepTicks.forEach(function (d, i) {
        d.classList.remove('is-active', 'is-done');
        if (i === idx) d.classList.add('is-active');
        else if (i < idx) d.classList.add('is-done');
      });
      currentIdx = idx;
      updateStepCounter();
      // If review step, build summary
      var step = schema.steps[idx];
      if (step && step.type === 'review') buildReview();
      // Smooth scroll
      panels[idx]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function showFirstVisible() {
      for (var i = 0; i < schema.steps.length; i++) {
        if (isStepVisible(schema.steps[i])) { showStep(i); return; }
      }
    }

    function goNext() {
      for (var i = currentIdx + 1; i < schema.steps.length; i++) {
        if (isStepVisible(schema.steps[i])) { showStep(i); return; }
      }
    }

    function goBack() {
      for (var i = currentIdx - 1; i >= 0; i--) {
        if (isStepVisible(schema.steps[i])) { showStep(i); return; }
      }
    }

    // ===== Validation =====
    function validateCurrentStep() {
      var step = schema.steps[currentIdx];
      if (!step) return true;
      if (!step.required) return true;
      if (step.type === 'name_input') {
        if (!nameInput || !nameInput.value.trim()) {
          if (nameError) {
            nameError.style.display = '';
            setTimeout(function () {
              if (nameError) nameError.style.display = 'none';
              if (nameInput) nameInput.classList.remove('rlz-cfg__name-input--error');
            }, 3500);
          }
          if (nameInput) {
            nameInput.classList.add('rlz-cfg__name-input--error');
            nameInput.focus();
          }
          return false;
        }
        return true;
      }
      // For option / extra_select steps, require a value to be selected
      if ((step.option || step.type === 'extra_select') && !state[step.id]) {
        var grp = root.querySelector('.rlz-cfg__panel[data-step-id="' + step.id + '"] .rlz-cfg__option-group');
        if (grp) {
          grp.classList.add('is-error');
          setTimeout(function () { grp.classList.remove('is-error'); }, 800);
        }
        return false;
      }
      return true;
    }

    // ===== Name input + lettering preview =====
    // Clean name (no trailing backslash) — goes to the cart property.
    function computeCleanName() {
      var raw = nameInput ? nameInput.value.trim() : '';
      // Strip any trailing backslash defensively (legacy users may paste it)
      while (raw.length && raw.charAt(raw.length - 1) === '\\') raw = raw.slice(0, -1);
      return raw;
    }

    // Display value for the lettering preview (uses backslash for heart ligature)
    function computeFinalName() {
      var clean = computeCleanName();
      if (!clean) return '';
      var wantsHeart = heartCheckbox && heartCheckbox.checked;
      return wantsHeart ? clean + '\\' : clean;
    }

    function syncNamePreview() {
      var clean = computeCleanName();
      var wantsHeart = heartCheckbox && heartCheckbox.checked;
      var raw = nameInput ? nameInput.value : '';
      if (charCount) charCount.textContent = raw.length;
      // Visible preview uses ligature (\\ → heart) so it stays beautiful
      if (previewText) {
        var preview = clean + (wantsHeart && clean ? '\\' : '');
        previewText.textContent = preview || (previewText.dataset.placeholder || 'il tuo nome');
        previewText.classList.toggle('is-placeholder', !clean);
      }
      // Cart property gets the CLEAN name only (no backslash)
      if (finalNameInput) finalNameInput.value = clean;
      // Separate "Cuore finale" property — empty when not checked, so Shopify drops it
      var heartInput = root.querySelector('[data-rlz-final-heart]');
      if (heartInput) heartInput.value = (wantsHeart && clean) ? heartYesLabel() : '';
    }

    function heartYesLabel() {
      var lang = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
      var map = { it: '✓ Sì', en: '✓ Yes', de: '✓ Ja', fr: '✓ Oui', es: '✓ Sí' };
      return map[lang] || map.en;
    }

    function applyLetteringColor(value) {
      if (!previewText) return;
      var color = colorForValue(value);
      var isGradient = color.indexOf('linear-gradient') === 0;
      if (isGradient) {
        previewText.style.color = 'transparent';
        previewText.style.background = color;
        previewText.style.webkitBackgroundClip = 'text';
        previewText.style.backgroundClip = 'text';
        previewText.style.filter = 'drop-shadow(0 1px 2px rgba(0,0,0,0.25))';
      } else {
        previewText.style.color = color;
        previewText.style.background = 'transparent';
        previewText.style.webkitBackgroundClip = 'border-box';
        previewText.style.backgroundClip = 'border-box';
        previewText.style.filter = '';
      }
    }

    // ===== Review summary =====
    function buildReview() {
      if (!reviewSummary) return;
      var html = '';
      schema.steps.forEach(function (step) {
        if (step.type === 'review') return;
        if (!isStepVisible(step)) return;
        var val = state[step.id];
        if (!val) return;
        var labelOverride = step.values && step.values[val] && step.values[val].label;
        var displayVal = labelOverride || val;
        // For name_input strip trailing backslash from display
        if (step.type === 'name_input') {
          while (displayVal.length && displayVal.charAt(displayVal.length - 1) === '\\') displayVal = displayVal.slice(0, -1);
        }
        var valueClass = 'rlz-cfg__review-row-value';
        if (step.type === 'name_input') valueClass += ' rlz-cfg__review-row-value--lettering';
        html += '<div class="rlz-cfg__review-row">' +
                  '<span class="rlz-cfg__review-row-key">' + escapeHtml(step.label || step.id) + '</span>' +
                  '<span class="' + valueClass + '">' + escapeHtml(displayVal) + '</span>' +
                '</div>';
        // If this is name_input + heart checked, add separate row for the heart
        if (step.type === 'name_input' && heartCheckbox && heartCheckbox.checked && displayVal) {
          var lang = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
          var heartLabelMap = { it: 'Cuore finale', en: 'Heart at the end', de: 'Herz am Ende', fr: 'Cœur final', es: 'Corazón final' };
          var heartLabel = heartLabelMap[lang] || heartLabelMap.en;
          html += '<div class="rlz-cfg__review-row">' +
                    '<span class="rlz-cfg__review-row-key">' + escapeHtml(heartLabel) + '</span>' +
                    '<span class="rlz-cfg__review-row-value">' + escapeHtml(heartYesLabel()) + '</span>' +
                  '</div>';
        }
      });
      reviewSummary.innerHTML = html || '<p>—</p>';
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    // ===== Add to cart =====
    // mode: 'checkout' = aggiunge poi naviga a /checkout
    //       'another'  = aggiunge poi mostra success inline + 2 scelte
    async function addToCart(mode) {
      var allBtns = root.querySelectorAll('[data-rlz-add-and-checkout], [data-rlz-add-and-personalize]');
      allBtns.forEach(function (b) { b.disabled = true; });
      try {
        // 1. Add main product
        var r = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        var data = await r.json();
        if (!data.id) {
          allBtns.forEach(function (b) { b.disabled = false; });
          alert(data.description || (window.rlzI18n && window.rlzI18n.error_retry) || 'Error. Please try again.');
          return;
        }
        // 2. If salta-coda toggle is ON, add it as separate line item
        if (typeof window.rlzAddSaltaCodaIfChecked === 'function') {
          try { await window.rlzAddSaltaCodaIfChecked(); } catch (e) {}
        }
        updateCartCount();
        // 3. Refresh cart-drawer section so its content matches the new cart state
        try {
          var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var sectionRes = await fetch(rootPath + '?section_id=cart-drawer', { credentials: 'same-origin' });
          if (sectionRes.ok) {
            var html = await sectionRes.text();
            var dom = new DOMParser().parseFromString(html, 'text/html');
            var fresh = dom.querySelector('cart-drawer');
            var existing = document.querySelector('cart-drawer');
            if (fresh && existing) existing.innerHTML = fresh.innerHTML;
          }
        } catch (e) { /* non-fatal */ }
        // 4. Behavior depends on mode
        if (mode === 'another') {
          // Inline success view above CTAs: "Aggiunto al carrello!" + 2 bottoni (Ricomincia / Vai alla cassa)
          showAddAnother();
        } else {
          // Default: OPEN cart drawer (NOT redirect to checkout — that was wrong UX).
          // Falls back to /cart navigation if no drawer exists.
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            // Re-enable buttons so user can interact after drawer closes
            allBtns.forEach(function (b) { b.disabled = false; });
            drawer.open();
          } else {
            window.location.href = '/cart';
          }
        }
      } catch (e) {
        allBtns.forEach(function (b) { b.disabled = false; });
        alert((window.rlzI18n && window.rlzI18n.error_network_retry) || 'Network error. Please try again.');
      }
    }

    // ===== Inline post-add success view (replaces CTA buttons in review step) =====
    function showAddAnother() {
      var actions = root.querySelector('[data-rlz-step-actions]');
      var another = root.querySelector('[data-rlz-another]');
      if (actions) actions.style.display = 'none';
      if (another) {
        another.style.display = 'block';
        // Update message with name if available
        var nameInputEl = root.querySelector('[data-rlz-final-name]');
        var msg = another.querySelector('[data-rlz-another-msg]');
        if (msg && nameInputEl && nameInputEl.value) {
          msg.textContent = '"' + nameInputEl.value + '" aggiunto al carrello!';
        }
        // Scroll into view
        var r = another.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          another.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    // ===== Reset configurator: torna a step 1 con state pulito =====
    function resetConfigurator() {
      // Clear state
      Object.keys(state).forEach(function (k) { delete state[k]; });
      // Reset name input + heart
      var nameInputEl = root.querySelector('[data-step-name-input]');
      var heartEl = root.querySelector('[data-rlz-heart]');
      var charCountEl = root.querySelector('[data-rlz-char-count]');
      var finalName = root.querySelector('[data-rlz-final-name]');
      var finalHeart = root.querySelector('[data-rlz-final-heart]');
      if (nameInputEl) nameInputEl.value = '';
      if (heartEl) heartEl.checked = false;
      if (charCountEl) charCountEl.textContent = '0';
      if (finalName) finalName.value = '';
      if (finalHeart) finalHeart.value = '';
      // Reset all none-toggles + their property inputs
      root.querySelectorAll('[data-rlz-none-toggle]').forEach(function (cb) { cb.checked = false; });
      root.querySelectorAll('[data-rlz-none-property]').forEach(function (inp) { inp.value = ''; });
      // Hide OOS messages so they recompute on next render
      root.querySelectorAll('[data-rlz-oos-message]').forEach(function (m) { m.style.display = 'none'; });
      // Reset preview lettering if present
      var preview = root.querySelector('[data-rlz-preview-text]');
      if (preview) { preview.textContent = i18n.lettering_placeholder || ''; }
      // Clear UI selections
      root.querySelectorAll('.rlz-cfg__color-swatch.is-selected, .rlz-cfg__img-swatch.is-selected, .rlz-cfg__option-pill.is-selected, .rlz-cfg__swatch.is-selected').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      // Hide success view, re-enable buttons
      var another = root.querySelector('[data-rlz-another]');
      var actions = root.querySelector('[data-rlz-step-actions]');
      if (another) another.style.display = 'none';
      if (actions) actions.style.display = '';
      root.querySelectorAll('[data-rlz-add-and-checkout], [data-rlz-add-and-personalize]').forEach(function (b) { b.disabled = false; });
      // Go back to first visible step (showFirstVisible accounts for conditional/hidden steps)
      if (typeof showFirstVisible === 'function') {
        showFirstVisible();
      } else if (typeof showStep === 'function') {
        showStep(0);
      }
      // Scroll configurator into view
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateCartCount() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
    }

    // ===== Utility =====
    function findStepById(id) {
      return schema.steps.find(function (s) { return s.id === id; });
    }

    // Initialize
    recomputeVisibility();
    updateAvailability();
    refreshAllOosSteps();
    refreshAllStockFilters();
  }
})();
